export const operationTimingModel = data => ({
    name: (data && data.name) || "",
    waitingTimes: ((data && data.waitingTimes) || []).map(Number),
    marketplaceWaitingTimes: ((data && data.marketplaceWaitingTimes) || []).map(Number),
    maxDeliveryTime: (data && data.maxDeliveryTime) || 0,
})